import storage from 'redux-persist/lib/storage';

export default {
  auth: {
    key: 'Auth',
    storage,
    whitelist: [ 'accessToken', 'user' ],
  },
};
